




















import { Component, Vue, Prop } from 'vue-property-decorator';

import { Form, FormOption } from '../models/form';
import DynamicFormField from './DynamicFormField.vue';
import DynamicFormOption from './DynamicFormOption.vue';

@Component({
  components: {
    DynamicFormField,
    DynamicFormOption,
  },
})
export default class DynamicFormComponent extends Vue {
  @Prop({ required: true })
  form!: Form;

  onSearch(params: any) {
    this.$emit('on-search', params);
  }

  onSelect(items: Array<FormOption>) {
    this.$emit('on-select', items);
  }
}
